import { intlLocale } from './datetime'

/**
 * Panoda gösterilen **yüzde** biçimi (079 — mockup "53 (%28,8)").
 *
 * Sunucu yüzdeyi bir ondalık basamağa yuvarlanmış bir sayı olarak gönderir (`28.8`); burada yalnız
 * **sunumu** yapılır: ondalık ayracı dile göre çözülür (TR virgül, EN nokta) ve **tam sayı olan değerde
 * ondalık yazılmaz** (`%20`, `%20,0` değil) — tabloyu gereksiz sıfırlarla doldurmamak için.
 *
 * Yüzde işaretinin **önde** olması bilinçlidir: uygulamanın her yerinde (`%75`, `%71,4`) Türkçe yazım
 * kuralına göre böyle yazılıyor; `Intl`'in `style: 'percent'` biçimi işareti sona koyardı.
 */
export function formatPercent(value: number, lang: string): string {
  return formatDecimal(value, lang)
}

/**
 * **Bir ondalıklı** sayı biçimi — yüzde olmayan panolar için ("18,4 gün"; 086 "Yönetici Bazlı Ortalama
 * Aksiyon Süresi"). Kural {@link formatPercent} ile birebir aynıdır (ayraç dile göre, tam sayıda ondalık
 * yazılmaz); ayrı ad, çağrı yerinde "bu bir yüzde değil" bilgisini taşır.
 */
export function formatDecimal(value: number, lang: string): string {
  return value.toLocaleString(intlLocale(lang), { maximumFractionDigits: 1 })
}
